import { render, staticRenderFns } from "./DataLayoutSwitcher.vue?vue&type=template&id=5b9f26ac&scoped=true&"
import script from "./DataLayoutSwitcher.vue?vue&type=script&lang=js&"
export * from "./DataLayoutSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f26ac",
  null
  
)

export default component.exports